import i18n from '../../i18n';

export class Text {
  static get viewAll(): string {
    return i18n._translate('View all', {
      context: 'A link above a row of cards letting the user know there are more to see when clicked.',
    });
  }
}
